import { render } from "./Auth.vue?vue&type=template&id=37a80ac8"
import script from "./Auth.vue?vue&type=script&lang=js"
export * from "./Auth.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/gizmorilla.com/toolbox.gizmorilla.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__